<div class="p-6 max-w-lg">
    <div class="flex items-start gap-3 mb-5">
        <div class="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5 text-blue-600">qr_code_2</mat-icon>
        </div>
        <div>
            <h2 class="text-base font-semibold text-slate-900">{{ 'easypassModes.sectionTitle' | translate }}</h2>
            <p class="text-sm text-slate-500 mt-0.5">{{ data.parkingSpace.name }}</p>
        </div>
    </div>

    @for (row of rows; track row.key) {
    <div class="flex items-center justify-between py-3 border-t border-slate-100">
        <div class="text-sm font-medium text-slate-900">{{ row.key | translate }}</div>
        <label class="relative inline-flex items-center cursor-pointer shrink-0">
            <input type="checkbox" class="sr-only peer" [checked]="row.value()"
                   (change)="row.value.set($any($event.target).checked)" />
            <div class="w-11 h-6 bg-slate-200 rounded-full transition-colors peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-100 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:h-5 after:w-5 after:rounded-full after:bg-white after:border after:border-slate-300 after:transition-all peer-checked:after:translate-x-5 peer-checked:after:border-white"></div>
        </label>
    </div>
    }

    <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-100">
        <jjames-button variant="ghost" (clicked)="onCancel()">{{ 'common.cancel' | translate }}</jjames-button>
        <jjames-button variant="primary" [disabled]="isSaving()" [loading]="isSaving()" (clicked)="onSave()">
            {{ 'common.save' | translate }}
        </jjames-button>
    </div>
</div>
